/**
* Asynchronouse Widget Loader Module
* 
* Module used to asynchronously load widgets on the fly.  
* Currently used in conjunction with the AsyncWidgetLoader widget
*/

var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};
SCM.SharedWidgets.UserPersonalization = SCM.SharedWidgets.UserPersonalization || {};

SCM.SharedWidgets.AsyncWidgetLoader = (function() {
    
    return {
        LoadWidget: loadWidget
    };

    /**
    * Uses the parameters to load a widget asynchronously using AJAX
    *
    * @param {string} elementClass - The CSS class on the DOM element
    * @param {string} elementAttrUrl - The data attribute to retrieve the URL of the AJAX call
    * @param {string} elementAttrParams - The data attribute to retrieve the parameters to be sent to the AJAX call
    */
    function loadWidget(elementClass, elementAttrUrl, elementAttrParams, requestType) {
        // Find all elements in the dom with the class and attribute
        var domItems = $(elementClass);

        domItems.each(function () {
            // Get the DOM object so that we can write to it after the AJAX call
            var domObj = $(this);
            // Get the relevant information about the AJAX call to be made
            var dataUrl = domObj.attr(elementAttrUrl);
            var dataParams = domObj.attr(elementAttrParams);
            var params = buildParameters(dataParams);
            $.ajax({
                url: dataUrl,
                data: params,
                type: requestType,
                success: function (html) {
                    // Write to the parent element, which is the AsyncWidgetLoader div
                    domObj.parent().replaceWith(html);

                    if (typeof SCM.EventEmitter == 'object') {
                        SCM.EventEmitter.publish(elementClass + '_LOADED');
                    }
                },
                error: function (xmlHttpRequest, textStatus, errorThrown) {
                    if (window.console) {
                        var err = eval('(' + xmlHttpRequest.responseText + ')');
                        console.error('error: ' + err);
                        console.error('status: ' + textStatus);
                    }
                }
            });
        });
    }

    function buildParameters(dataParams) {
        var parsed = JSON.parse(dataParams);
        var items = parsed.parameters;
        var localParams = parsed.dynamicParameters;

        if (localParams !== undefined && localParams.localParams !== undefined && localParams.localParams === '[REPLACE_WITH_LOCAL]') {
            var localStore = SCM.SharedWidgets.UserPersonalization.GetFromLocalStorage();
            localParams.localParams = localStore;
            items.Items = JSON.stringify(localStore);
        }
        return items;
    }
})();

jQuery(document).ready(function ($) {
    SCM.SharedWidgets.AsyncWidgetLoader.LoadWidget('.SCM-SharedWidgets-AsyncWidgetLoader', 'data-url', 'data-params', 'POST');
});
